<template>
  <section class="section is-fullheight">
    <admin-section-header icon="bell" title="Notificaciones" />
    <SectionUnderDevelopment text="No tiene notificaciones"/>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import SectionUnderDevelopment from '@/components/common/SectionUnderDevelopment.vue'

export default {
  name: 'Notifications',
  components: { AdminSectionHeader, SectionUnderDevelopment },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Notifications'],
      title: 'Notifications'
    })
  }
}
</script>

<style scoped>
.is-ancestor {
  height: calc(100% - 80px);
}

.tile.is-child {
  border: solid 1.5px var(--rosa-dark-eco);
  border-radius: 10px;
}
.notification-area {
  overflow: scroll;
}
.notification-area .text-icon-tile {
  border: solid 2px;
  border-radius: 10px;
  padding: 10px;
}
.notification-row {
  margin: 1em;
}
.notification-title {
  border-bottom: solid 2px var(--rosa-eco);
}
.side-tiles .tile {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}
.rating .level {
  margin: 0;
}
</style>
